import { render, staticRenderFns } from "./TextRender.vue?vue&type=template&id=73e4ba78&scoped=true&"
import script from "./TextRender.vue?vue&type=script&lang=ts&"
export * from "./TextRender.vue?vue&type=script&lang=ts&"
import style0 from "./TextRender.vue?vue&type=style&index=0&id=73e4ba78&scoped=true&lang=scss&"
import style1 from "./TextRender.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4ba78",
  null
  
)

export default component.exports